// extracted by mini-css-extract-plugin
export default {"center":"Doorstep_center__5x3EJ"};